import React from "react";
import { Modal } from "react-bootstrap";
import "../styles/GenericModalStyle.css";
import { Row, Col } from "reactstrap";
import close from "../../app/features2/learning_room/assets/images/closeimg.png";
import strings from "../utils/Strings";

interface GenericModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  content: React.ReactNode; // Change to ReactNode
}

const GenericModal: React.FC<GenericModalProps> = ({
  show,
  handleClose,
  title,
  content,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="generic-modal"

      // style={title === strings.modal.Terms ? { width: "400px" } : {}}
    >
      <Modal.Body
        className="T-C-popup"
        style={
          title === strings.modal.Terms
            ? { width: "750px", height: "300px" }
            : { width: "750px", height: "400px" }
        }
      >
        <div className="T-C-popup-content">
          <Row>
            <Col md={10}>
              <h4 className="TC-title">{title}</h4>
            </Col>{" "}
            <Col md={2} className="text-end">
              <img
                src={close}
                alt="Close"
                height="35px"
                width="35px"
                onClick={handleClose}
                className="TC-button"
              />
            </Col>
          </Row>
          <div
            style={{
              height: "2px",
              backgroundColor: "#EAEAEA",
              margin: "15px  0px",
            }}
          ></div>
          {/* <Row className="TC-title">{title}</Row> */}
          {/* <br></br> */}
          <Row className="TC-content">{content}</Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GenericModal;
